import React from "react";
import { createPortal } from "react-dom";

import OverCreditBanner from "../../../../../components/Paywall/OverCreditBanner";

/** Out-of-credits banner, portaled into the Routes page notice slot. */
export default function OptimizationNotice() {
  const target = document.getElementById("route-builder-optimization-notice");
  if (!target) return null;

  return createPortal(
    <OverCreditBanner
      message="You've used all route optimization credits for this month."
      linkTo="/admin/settings/billing?show-plans=1"
      linkText="Upgrade your plan to optimize more routes."
    />,
    target,
  );
}
